import namespace from './namespace';

export default {
    [namespace.mutations.SET_MAPPINGS_VALUES] (state, responseData) {
        if (responseData.groupedMappings !== undefined) {
            state[namespace.state.MAPPINGS_GROUPS] = responseData.groupedMappings;
        }
        if (responseData.jiraFields !== undefined) {
            state[namespace.state.AVAILABLE_JIRA_VALUES] = responseData.jiraFields;
        }
        if (responseData.tfsFields !== undefined) {
            state[namespace.state.AVAILABLE_TFS_VALUES] = responseData.tfsFields;
        }
    },
    [namespace.mutations.SHOW_LOADER] (state, loaderVisible) {
        state[namespace.state.LOADER_VISIBLE] = loaderVisible;
    },
    [namespace.mutations.SET_SELECTED_JIRA_FIELD](state, value){
        if(value === undefined || value === null){
            state[namespace.state.SELECTED_JIRA_FIELD] = null;
        }
        else{
            state[namespace.state.SELECTED_JIRA_FIELD] = value;
        }
    },
    [namespace.mutations.SET_SELECTED_TFS_FIELD](state, value){
        if(value === undefined || value === null){
            state[namespace.state.SELECTED_TFS_FIELD] = null;
        }
        else{
            state[namespace.state.SELECTED_TFS_FIELD] = value;
        }
    },
    [namespace.mutations.UPDATE_MAPPINGS](state, responseData){
        if (responseData.groupedMappings !== undefined) {
            state[namespace.state.MAPPINGS_GROUPS] = responseData.groupedMappings;
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/fieldsMapping/mutations.js